import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { AlertaAprobacion } from '../_models/alerta-aprobacion';

@Injectable({
  providedIn: 'root'
})
export class AlertaAprobacionService {
  private rutServicio = AppSettings.rutServiciosAPL + '/api/alertasAprobaciones';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as AlertaAprobacion[] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( `${this.rutServicio}/enabled` ).pipe( map( res => res as AlertaAprobacion[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( `${this.rutServicio}/${id}` ).pipe( map( res => res as AlertaAprobacion ) );
  }

  obtenerPorIdAlerta( id: string ) {
    return this.httClient.get( `${this.rutServicio}/alerta/${id}` ).pipe( map( res => res as AlertaAprobacion[] ) );
  }

  crear( regCrear: AlertaAprobacion ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as AlertaAprobacion ) );
  }

  actualizar( regActualizar: AlertaAprobacion ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regActualizar ).pipe( map( res => res as any ) );
  }

  bulk( registros: AlertaAprobacion[] ) {
    registros.forEach( r => r.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado() );
    return this.httClient.post( `${this.rutServicio}/bulk`, registros ).pipe( map( res => res as any ) );
  }
}
